import { render, staticRenderFns } from "./PersonalCenterShare.vue?vue&type=template&id=2baeb388&scoped=true&"
import script from "./PersonalCenterShare.vue?vue&type=script&lang=js&"
export * from "./PersonalCenterShare.vue?vue&type=script&lang=js&"
import style0 from "./PersonalCenterShare.vue?vue&type=style&index=0&id=2baeb388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baeb388",
  null
  
)

export default component.exports